import { render, staticRenderFns } from "./Pos_choose_product.vue?vue&type=template&id=1fc9482b&scoped=true&"
import script from "./Pos_choose_product.vue?vue&type=script&lang=js&"
export * from "./Pos_choose_product.vue?vue&type=script&lang=js&"
import style0 from "./Pos_choose_product.vue?vue&type=style&index=0&id=1fc9482b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc9482b",
  null
  
)

export default component.exports